import NgMenue from './ng-menue';
import cssVar from '../lib/css-var';

const mobileMenuTrigger = () => {

  /*
   * DOM elements
   * @type {Node}
   */
  const body = document.querySelector('body');
  const header = document.querySelector('header');
  const burgerMenues = document.querySelectorAll('.ce_rsce_burger_menu');

  /*
   * Css Variable
   * @type {function}
   */
  const breakpoint = cssVar('nav-bh-mw').replace('px', '');

  /*
   * classes
   * @type {string}
   */
   const OPEN_CLASS = 'is-open';
   const HEADER_EFFECT_CLASS = 'bs-bl';
   const MOBILE_CLASS = 'is-mobile';

  /*
   * Check Menues
   * @type {node}
   */
  if(!burgerMenues) {
    return;
  }

  /*
   * Trigger
   * @type {node}
   */
  burgerMenues.forEach((burger) => {

    if(!burger.parentElement.querySelector('.mod_navigation.mobile-navigation')) {
      return;
    }

    /*
     * Navigation
     * @type {node}
     */
    const navigation = burger.parentElement.querySelector('.mod_navigation.mobile-navigation');

    /*
     * Event Listener
     * @type {listener}
     */
    burger.addEventListener('click', () => {
      header.classList.toggle(HEADER_EFFECT_CLASS);
      burger.classList.toggle(OPEN_CLASS);
      navigation.classList.toggle(OPEN_CLASS);
      toggleBodyOverflow();
    });

    /*
     * Event Listener / Remove on click
     * @type {listener}
     */
    navigation.querySelectorAll('a').forEach((link) => {
      if(typeof(link.getAttribute('href')) === 'string' && link.getAttribute('href').includes(location.pathname.substr(1) + '#')) {
        link.addEventListener('click', () => {
          header.classList.remove(HEADER_EFFECT_CLASS);
          burger.classList.remove(OPEN_CLASS);
          navigation.classList.remove(OPEN_CLASS);
          body.style.overflowY = null;
          // body.style.position = null;
        });
      }
    });

    /*
     * Event Listener / Resizer
     * @type {listener}
     */
    window.addEventListener('resize', () => {
      if (body.offsetWidth > breakpoint) {
        header.classList.remove(HEADER_EFFECT_CLASS);
        burger.classList.remove(OPEN_CLASS);
        navigation.classList.remove(OPEN_CLASS);
        navigation.classList.remove(MOBILE_CLASS);
        body.style.overflowY = null;
        // body.style.position = null;
      } else {
        navigation.classList.add(MOBILE_CLASS);
      }
    });

    /*
     * Overflow
     * @type {function}
     */
    function toggleBodyOverflow() {
      if(body.style.overflowY === "hidden") {
        body.style.overflowY = null;
        // body.style.position = null;
      } else {
        body.style.overflowY = "hidden";
        // body.style.position = "relative";
      }
    }

    /*
     * Add Classes
     * @type {CLASS}
     */
    new NgMenue(navigation, breakpoint);

    window.dispatchEvent(new Event('resize'));
  });
}

export default mobileMenuTrigger;
